
import {
  features,
  solutions,
  popularServices,
  questions,
} from "~/data/products";
import Modal from "~/components/rebranding/modal/Modal.vue";

export default {
  data() {
    return {
      activeSection: "",
      FormTitle: "",
      features,
      solutions,
      popularServices,
      questions,
      quickSections: [
        { id: "features", label: "ویژگی‌ها" },
        { id: "solutions", label: "رشد زیرساخت‌های ابری" },
        { id: "standards", label: "استانداردهای امنیتی" },
        { id: "support", label: "مشاوره" },
        { id: "popular-services", label: "خدمات پرکاربرد" },
        { id: "faq", label: "سوالات متداول" },
      ],
    };
  },
  components: {
    Modal,
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "محصولات آبالون | از دیتاسنتر ابری تا شبکه توزیع محتوا",
      meta: [
        {
          name: "description",
          content:
            "محصولات آبالون | ابزارها و سرویس‌های ابری و دیتاسنتری | رایانش ابری، شبکه توزیع محتوا، خدمات دیتاسنتر و پایداری داده |‌ پیاده‌سازی سریع بدون پیچیدگی",
        },
        {
          name: "keywords",
          content: "محصولات آبالون",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/products",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "محصولات آبالون | از دیتاسنتر ابری تا شبکه توزیع محتوا",
        },
        {
          property: "og:description",
          content:
            "محصولات آبالون | ابزارها و سرویس‌های ابری و دیتاسنتری | رایانش ابری، شبکه توزیع محتوا، خدمات دیتاسنتر و پایداری داده |‌ پیاده‌سازی سریع بدون پیچیدگی",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/products",
        },
        {
          name: "twitter:title",
          title: "محصولات آبالون | از دیتاسنتر ابری تا شبکه توزیع محتوا",
        },
        {
          name: "twitter:description",
          content:
            "محصولات آبالون | ابزارها و سرویس‌های ابری و دیتاسنتری | رایانش ابری، شبکه توزیع محتوا، خدمات دیتاسنتر و پایداری داده |‌ پیاده‌سازی سریع بدون پیچیدگی",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/products",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "محصولات آبالون کدام بخش‌های راهکارهای ابری را پوشش می‌دهند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "محصولات آبالون مجموعه‌ای از ابزارها و راهکارهای پیشرفته ابری هستند که به سازمان‌ها کمک می‌کنند فرایندها را ساده‌تر مدیریت کنند، امنیت و پایداری را افزایش دهند و بهینه‌ترین معماری‌ ابری را تجربه کنند. این محصولات شامل سرویس‌های پردازشی و زیرساختی مانند سرورهای ابری و دیتاسنتر ابری مقیاس‌پذیر، شبکه توزیع محتوا (CDN) برای بهبود سرعت و امنیت محتوای وب‌سایت و سرویس‌های آنلاین، خدمات دیتاسنتر شامل سرور اختصاصی و کولوکیشن، راهکارهای پایداری داده شامل ذخیره‌سازی (آبجکت استوریج)، پشتیبان‌گیری و بازیابی از بحران (DR) و شبکه ابری با مدیریت بهینه ترافیک و دسترسی بدون محدودیت به منابع داخلی و بین‌المللی (تحریم‌شکن) می‌شوند.",
                },
              },
              {
                "@type": "Question",
                name: "محصولات آبالون چگونه به افزایش سرعت و عملکرد فرآیندهای سازمانی کمک می‌کنند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "محصولات آبالون با فراهم کردن منابع پردازشی و ذخیره‌سازی سریع و مقیاس‌پذیر، امکان اجرای بلادرنگ و بدون وقفه سرویس‌ها و برنامه‌های سازمانی را ایجاد می‌کنند. شبکه توزیع محتوا (CDN) سرعت دسترسی به داده‌ها و سرویس‌های آنلاین را افزایش می‌دهد، شبکه ابری اختصاصی ترافیک را بهینه مدیریت می‌کند و ارتباط پایدار میان شعب و دفاتر سازمان را برقرار می‌کند. علاوه بر این، راهکارهای پایداری داده و خدمات دیتاسنتر، اطمینان می‌دهند که فرآیندها در برابر خرابی سخت‌افزار، خطاهای انسانی یا حملات سایبری دچار وقفه نشوند، تا عملکرد سازمان همیشه پایدار و سریع باقی بماند.",
                },
              },
              {
                "@type": "Question",
                name: "محصولات آبالون چگونه امنیت داده‌ها و سرویس‌های سازمان را بدون نیاز به تجهیزات سخت‌افزاری فراهم می‌آورند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "شبکه توزیع محتوا (CDN) آبالون نه‌تنها سرعت دسترسی به محتوا را افزایش می‌دهد، بلکه با مکانیزم‌های پیشرفته امنیتی از داده‌ها و سرویس‌های شما در برابر حملات سایبری مانند DDoS محافظت می‌کند. راهکارهای پایداری داده شامل آبجکت استوریج، بکاپ سرور ابری و بازیابی از بحران (DR) از اطلاعات شما در برابر خرابی سخت‌افزار، خطاهای انسانی و حملات سایبری محافظت می‌کنند. علاوه بر این، شبکه اختصاصی و ایزوله نورونتا و خدمات دیتاسنتر، دسترسی امن و پایدار به سرویس‌ها و ارتباط داخلی میان شعب و دفاتر سازمان را تضمین می‌کنند و امنیت چندلایه را بدون پیچیدگی‌های فنی برای سازمان فراهم می‌آورند.",
                },
              },
              {
                "@type": "Question",
                name: "محصولات آبالون در بخش ذخیره‌سازی چه امکاناتی در اختیار سازمان‌ها قرار می‌دهند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "محصولات آبالون در بخش ذخیره‌سازی، امکانات جامعی برای مدیریت داده‌های سازمانی ارائه می‌دهند. این سرویس‌ها شامل آبجکت استوریج برای داده‌های حجیم، بکاپ ابری برای نسخه‌های پشتیبان زمان‌بندی‌شده و بازیابی از بحران (DR) برای اطمینان از تداوم سرویس‌های سازمان در شرایط بحران هستند. با این امکانات، سازمان‌ها می‌توانند بدون نیاز به تجهیزات سخت‌افزاری اضافی، داده‌ها و سرویس‌های حیاتی خود را در برابر خرابی سخت‌افزار، خطاهای انسانی، حملات سایبری یا به‌روزرسانی‌های ناموفق محافظت کرده و دسترسی پایدار و امن به اطلاعات داشته باشند.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "محصولات آبالون",
            },
            author: {
              "@type": "Person",
              name: "Amirhosein",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
